'use client'

import { BuilderBlocks } from '@builder.io/react'
import { uniqueId } from 'lodash'
import { type ReactNode } from 'react'
import React from 'react'

import {
  type Spacing,
  getInnerSpacingClassNames,
  getOuterSpacingClassNames,
} from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode[] | ReactNode
  includedChildren?: any[]
  attributes?: any
  innerSpacing?: Spacing
  outerSpacing?: Spacing
}

export const Container = ({
  className,
  children,
  innerSpacing,
  includedChildren,
  outerSpacing,
  ...props
}: ContainerProps) => {
  const { builderState, builderBlock, attributes, ...containerProps } = props as any
  const shouldRenderBuilderBlocks = () => {
    return !React.Children.count(children)
  }
  return (
    <div
      {...attributes}
      key={attributes?.key}
      className={cn(
        'mx-auto w-full max-w-(--breakpoint-2xl) px-10 lg:px-32 ',
        getOuterSpacingClassNames(outerSpacing),
        className,
        attributes?.className
      )}
      style={attributes?.style}
      {...containerProps}
      suppressHydrationWarning
    >
      <div className={cn('w-full', getInnerSpacingClassNames(innerSpacing))}>
        {shouldRenderBuilderBlocks()
          ? includedChildren?.map((child, index) => (
              <BuilderBlocks
                key={uniqueId()}
                parentElementId={builderBlock?.id}
                dataPath={`component.options.includedChildren.${index}.item`}
                blocks={child.item}
                style={{ minHeight: '200px' }}
              />
            ))
          : children}
      </div>
    </div>
  )
}
